import { friendlyDbMessage } from "../../db/httpExecutor";

/**
 * WHAT A PERSON READS WHEN SOMETHING FAILS (spec §87.22).
 *
 * Domain errors (ValidationError and friends) are already sentences written
 * for people and pass through. Anything that reads like the machinery —
 * database text, a JavaScript TypeError, "[object Object]" — becomes the
 * fallback the screen supplies, and the original goes to the console for
 * the diagnostic record.
 */
const TECHNICAL = /TypeError|ReferenceError|undefined is not|cannot read propert|is not a function|\[object Object\]|NetworkError|Failed to fetch|stack|at .+\(.+:\d+:\d+\)/i;

export function userMessage(err: unknown, fallback: string): string {
  const raw = err instanceof Error ? err.message : typeof err === "string" ? err : "";
  if (!raw.trim()) return fallback;
  const friendly = friendlyDbMessage(raw);
  if (friendly !== raw) {
    console.error(err);
    return friendly;
  }
  if (TECHNICAL.test(raw) || raw.length > 400) {
    console.error(err);
    return fallback;
  }
  return raw;
}
